import styled from "styled-components";

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.75rem;
`;

export const StatItem = styled.div`
  display: flex;
  flex-direction: column;
  gap: 0.2rem;
`;

export const StatLabel = styled.span`
  font-size: 0.8rem;
  color: ${props => props.theme.colors.muted};

  span {
    color: ${props => props.theme.colors.danger};
    font-size: 0.75rem;
  }
`;

export const StatValue = styled.span<{ available: boolean }>`
  font-size: 1rem;
  font-weight: 600;
  color: ${props => props.available ? props.theme.colors.success : props.theme.colors.danger};
`;

export const WeightBar = styled.div`
  width: 100%;
  height: 6px;
  background: ${props => props.theme.colors.borderLight};
  border-radius: 3px;
  overflow: hidden;
`;

export const WeightFill = styled.div<{ pct: number }>`
  height: 100%;
  width: ${props => props.pct}%;
  background: ${props => props.theme.colors.primary};
  border-radius: 3px;
  transition: width 0.3s ease;
`;

export const AlertBadge = styled.span`
  font-size: 0.75rem;
  color: ${props => props.theme.colors.danger};
  font-weight: 600;
`;
